import * as AbsintheSocket                  from '@absinthe/socket'
import { createAbsintheSocketLink }         from '@absinthe/socket-apollo-link'
import { ApolloLink }  from 'apollo-link'
import { Socket as PhoenixSocket }          from 'phoenix'

import apolloProvider from './apolloProvider'

const WS_URL = "/socket"

function getAuthToken() {
  return localStorage.getItem('cardstock_auth_token')
}

function createPhoenixSocket(authToken) {
  var socket = new PhoenixSocket(WS_URL, {
    params: {
      auth: authToken
    }
  })

  socket.onOpen(
    () => {
      console.log('Cardstock: socketLink opened')
      apolloProvider.defaultClient.writeData({ data: { online: true } })
    }
  )

  socket.onError(
    () => { 
      console.log('Cardstock: socketLink detected error')
      apolloProvider.defaultClient.writeData({ data: { online: false } }) 
    }
  )

  socket.onClose(
    () => {
      console.log('Cardstock.socketLink detected close')
      apolloProvider.defaultClient.writeData({ data: { online: false } }) 
    }
  )

  // socket.onMessage(
  //   (message) => {
  //     console.log('Cardstock.socketLink detected message')
  //     console.info(message)

  //     // apolloProvider.defaultClient.writeData({ data: { online: false } }) 
  //   }
  // )

  return socket
}

function createInnerSocketLink(phoenixSocket) {
  const absintheSocket = AbsintheSocket.create(phoenixSocket)
  return createAbsintheSocketLink(absintheSocket)
}

class SocketLink extends ApolloLink {
  constructor() {
    super()
    this.token = getAuthToken()
    this.socket = createPhoenixSocket(this.token)
    this.link = createInnerSocketLink(this.socket)
  }

  request(operation, forward) {
    return this.link.request(operation, forward)
  }

  reset() {
    this.token = getAuthToken()
    this.socket.disconnect()
    this.socket = createPhoenixSocket(this.token)
    this.link = createInnerSocketLink(this.socket)
  }
}

export default new SocketLink()
